<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M27.9998 16.2933C27.9998 8.97333 22.3198 4 15.9998 4C9.7465 4 3.99984 8.86667 3.99984 16.3733C3.19984 16.8267 2.6665 17.68 2.6665 18.6667V21.3333C2.6665 22.8 3.8665 24 5.33317 24H6.6665V15.8667C6.6665 10.7067 10.8398 6.53333 15.9998 6.53333C21.1598 6.53333 25.3332 10.7067 25.3332 15.8667V25.3333H14.6665V28H25.3332C26.7998 28 27.9998 26.8 27.9998 25.3333V23.7067C28.7865 23.2933 29.3332 22.48 29.3332 21.52V18.4533C29.3332 17.52 28.7865 16.7067 27.9998 16.2933Z"
      class="fill-current"
    />
    <path
      d="M11.9998 18.6667C12.7362 18.6667 13.3332 18.0697 13.3332 17.3333C13.3332 16.597 12.7362 16 11.9998 16C11.2635 16 10.6665 16.597 10.6665 17.3333C10.6665 18.0697 11.2635 18.6667 11.9998 18.6667Z"
      class="fill-current"
    />
    <path
      d="M19.9998 18.6667C20.7362 18.6667 21.3332 18.0697 21.3332 17.3333C21.3332 16.597 20.7362 16 19.9998 16C19.2635 16 18.6665 16.597 18.6665 17.3333C18.6665 18.0697 19.2635 18.6667 19.9998 18.6667Z"
      class="fill-current"
    />
    <path
      d="M23.9996 14.7067C23.3596 10.9067 20.053 8 16.0663 8C12.0263 8 7.67963 11.3467 8.0263 16.6C11.3196 15.2533 13.7996 12.32 14.5063 8.74667C16.253 12.2533 19.8396 14.6667 23.9996 14.7067Z"
      class="fill-current"
    />
  </svg>
</template>
